export const en = {
  hero: {
    headline: {
      line1: "I didn't go viral.",
      line2: "I didn't get lucky.",
      span: 'I built a system.',
    },
    microproof: {
      system: 'Structured System',
      framework: 'Real Framework',
      results: 'Documented Results',
    },
    subheadline:
      'The structured framework behind my growth, positioning, and monetization — simplified so you can build your own digital income presence without wasting months guessing.',
    cta: 'Get Instant Access',
    trust: 'Instant download after purchase',
  },
  proofBar: {
    growth: {
      label: 'Growth',
      value: '1,847 followers',
      sub: 'in 90 days',
    },
    engagement: {
      label: 'Engagement',
      value: '4.8% rate',
      sub: 'consistent activity',
    },
    revenue: {
      label: 'Revenue',
      value: '$77,509+',
      sub: 'documented earnings',
    },
  },
  patternInterrupt: {
    headline: {
      line1: 'The truth most online courses',
      span: "won't tell you",
    },
    bullets: [
      'Most women online chase visibility.',
      'They copy trends.',
      'They wait for confidence.',
      'They hope something goes viral.',
      'Then they burn out.',
    ],
    quote: {
      text: 'Income online is not built on attention. It’s built on positioning.',
      sub: 'My growth wasn’t luck. It was structure.',
    },
  },
  problemAgitation: {
    headline: {
      line1: 'Why most creators',
      span: 'stay invisible',
    },
    influencer: {
      title: 'The Struggle',
      items: ['Random posting', 'No strategy', 'No positioning', 'No system'],
    },
    brandOperator: {
      title: 'Brand Operator',
      items: [
        'Builds authority',
        'Positions intentionally',
        'Monetizes visibility',
        'Gets paid',
      ],
    },
    footer: 'This system was built for the second.',
  },
  systemBreakdown: {
    headline: {
      line1: 'The 3-Pillar',
      span: 'Monetization Structure',
    },
    pillars: [
      {
        title: 'Identity Authority',
        desc: 'How to position your presence so people respect your brand instead of scrolling past it.',
      },
      {
        title: 'Structured Growth',
        desc: 'The repeatable workflow that removes guesswork and eliminates burnout.',
      },
      {
        title: 'Monetization Alignment',
        desc: 'How visibility becomes income when positioning is correct — without chasing clients.',
      },
    ],
  },
  systemFramework: {
    label: 'The Framework',
    headline: {
      line1: 'From Chaos to',
      span: 'System',
    },
    steps: ['CLARITY', 'STRUCTURE', 'EXECUTION', 'PRESENCE', 'MONETIZATION'],
  },
  quickWin: {
    headline: {
      line1: 'What you can apply',
      span: 'today',
    },
    subheadline: 'Immediate implementation, no fluff.',
    items: [
      'Weekly system structure',
      'Strategic posting logic',
      'Caption writing method',
      'Positioning clarity',
    ],
  },
  authorityTimeBlock: {
    line1: 'It took months of testing to build this system.',
    line2: 'You can spend the next year guessing.',
    line3: 'Or install the structure today.',
  },
  pricing: {
    badge: 'Limited Time',
    label: 'Limited Time Offer',
    headline: 'Launch Access',
    subheadline: 'The complete system to restructure your digital presence.',
    valueLabel: 'System Value',
    todayLabel: 'Today',
    trust: {
      payment: 'One-time payment',
      access: 'Instant access',
    },
    cta: 'Get Instant Access',
    footer: 'Price may increase',
    timer: 'Price increases after timer ends',
  },
  authorityClose: {
    headline: {
      line1: "You don't need luck.",
      span: 'You need structure.',
    },
    cta: 'Access System Now',
    copyright: '© 2024 The Luxury Content System™. All Rights Reserved.',
  },
}

export const es = {
  hero: {
    headline: {
      line1: 'No me hice viral.',
      line2: 'No tuve suerte.',
      span: 'Construí un sistema.',
    },
    microproof: {
      system: 'Sistema Estructurado',
      framework: 'Framework Real',
      results: 'Resultados Documentados',
    },
    subheadline:
      'El marco estructurado detrás de mi crecimiento, posicionamiento y monetización — simplificado para que construyas tu propia presencia digital sin perder meses adivinando.',
    cta: 'Obtener Acceso Inmediato',
    trust: 'Descarga instantánea tras la compra',
  },
  proofBar: {
    growth: {
      label: 'Crecimiento',
      value: '1,847 seguidores',
      sub: 'en 90 días',
    },
    engagement: {
      label: 'Engagement',
      value: '4.8% tasa',
      sub: 'actividad consistente',
    },
    revenue: {
      label: 'Ingresos',
      value: '$77,509+',
      sub: 'ganancias documentadas',
    },
  },
  patternInterrupt: {
    headline: {
      line1: 'La verdad que la mayoría de cursos',
      span: 'no te dirán',
    },
    bullets: [
      'La mayoría persigue visibilidad.',
      'Copian tendencias.',
      'Esperan tener confianza.',
      'Esperan volverse virales.',
      'Luego se queman.',
    ],
    quote: {
      text: 'Los ingresos online no se construyen con atención. Se construyen con posicionamiento.',
      sub: 'Mi crecimiento no fue suerte. Fue estructura.',
    },
  },
  problemAgitation: {
    headline: {
      line1: 'Por qué la mayoría',
      span: 'sigue invisible',
    },
    influencer: {
      title: 'La Lucha',
      items: [
        'Publicar al azar',
        'Sin estrategia',
        'Sin posicionamiento',
        'Sin sistema',
      ],
    },
    brandOperator: {
      title: 'Operadora de Marca',
      items: [
        'Construye autoridad',
        'Se posiciona intencionalmente',
        'Monetiza la visibilidad',
        'Genera ingresos',
      ],
    },
    footer: 'Este sistema fue construido para la segunda.',
  },
  systemBreakdown: {
    headline: {
      line1: 'La Estructura de',
      span: 'Monetización de 3 Pilares',
    },
    pillars: [
      {
        title: 'Autoridad de Identidad',
        desc: 'Cómo posicionar tu presencia para que respeten tu marca en lugar de ignorarla.',
      },
      {
        title: 'Crecimiento Estructurado',
        desc: 'El flujo de trabajo repetible que elimina las adivinanzas y el agotamiento.',
      },
      {
        title: 'Alineación de Monetización',
        desc: 'Cómo la visibilidad se convierte en ingresos cuando el posicionamiento es correcto — sin perseguir clientes.',
      },
    ],
  },
  systemFramework: {
    label: 'El Framework',
    headline: {
      line1: 'Del Caos al',
      span: 'Sistema',
    },
    steps: ['CLARIDAD', 'ESTRUCTURA', 'EJECUCIÓN', 'PRESENCIA', 'MONETIZACIÓN'],
  },
  quickWin: {
    headline: {
      line1: 'Lo que puedes aplicar',
      span: 'hoy mismo',
    },
    subheadline: 'Implementación inmediata, sin relleno.',
    items: [
      'Estructura de sistema semanal',
      'Lógica estratégica de publicación',
      'Método de escritura de captions',
      'Claridad de posicionamiento',
    ],
  },
  authorityTimeBlock: {
    line1: 'Tomó meses de pruebas construir este sistema.',
    line2: 'Puedes pasar el próximo año adivinando.',
    line3: 'O instalar la estructura hoy.',
  },
  pricing: {
    badge: 'Tiempo Limitado',
    label: 'Oferta por Tiempo Limitado',
    headline: 'Acceso de Lanzamiento',
    subheadline: 'El sistema completo para reestructurar tu presencia digital.',
    valueLabel: 'Valor del Sistema',
    todayLabel: 'Hoy',
    trust: {
      payment: 'Pago único',
      access: 'Acceso inmediato',
    },
    cta: 'Obtener Acceso Inmediato',
    footer: 'El precio puede aumentar',
    timer: 'El precio aumenta al terminar el contador',
  },
  authorityClose: {
    headline: {
      line1: 'No necesitas suerte.',
      span: 'Necesitas estructura.',
    },
    cta: 'Acceder al Sistema Ahora',
    copyright:
      '© 2024 The Luxury Content System™. Todos los derechos reservados.',
  },
}
